module.exports = __webpack_public_path__ + "static/sun_gif-187e814f91d9d37c4a2cd7db6b947128.webp";